<template>
    <div ref="scrollRef">
        <img :src="require('@/assets/img/database/banner.jpg')" alt="" style="width: 100%" data-aos="zoom-out">
        <div class="introduce" data-aos="flip-down">
            <div>
                <div v-for="(item,index) in introduceList" @click="introduceListHover(index)" :class="index===active?'active':''"
                     :style="{
                        'border-left':active===0?'none':active===1?'none':'1px solid #e6e6e6',
                        'border-right':active===2?'none':'1px solid #e6e6e6',
                     }"
                >
                    <img :src="require('@/assets/img/products/'+item.img+'.png')" alt="" >
                    <div v-html="item.title"></div>
                </div>
            </div>
        </div>
        <router-view @menuSelect="menuSelect"></router-view>
    </div>
</template>

<script>
export default {
	data() {
		return {
		  introduceList:[
              {
                  title:'EH-ODS<br>组学数据整合平台解决方案',
                  img:'introduce1'
              },
              {
                  title:'EH-CDS<br>临床数据整合平台解决方案',
                  img:'introduce2'
              },
          ],
          active:0,
          activeList:[
              {
                  active:0,
                  link:['bioOmics','privaCore','bioAnalyst','sciAnalyst','omicsVison','odsStorage','odsService','odsDownload']
              },
              {
                  active:1,
                  link:['sciSmart','holoData','dataLink','clinTrace','clinAnalyst','clinTrial','clinProject','digiCohort','clinVison','cdsStorage','cdsService','cdsDownload']
              },
          ]
        }
	},
	mounted(){
        // this.$router.push({
		// 	path:'/database/bioOmics'
		// })
        this.$nextTick(()=>{
            for (let i=0;i<this.activeList.length;i++){
                for (let j=0;j<this.activeList[i].link.length;j++){
                    if (this.$route.path.indexOf(this.activeList[i].link[j]) > 0){
                        this.active = this.activeList[i].active
                        return
                    }
                }
            }
        })
	},
    watch:{
        $route(to,from) {
            this.$nextTick(()=>{
                for (let i=0;i<this.activeList.length;i++){
                    for (let j=0;j<this.activeList[i].link.length;j++){
                        if (to.path.indexOf(this.activeList[i].link[j]) > 0){
                            this.active = this.activeList[i].active
                            return
                        }
                    }
                }
            })

        }
      },
    methods:{
	    menuSelect(src){
	        if (src.indexOf('/img') > -1){
	            return
            }
            this.$router.push({
                path:src
            })
        },
        introduceListHover(index){
	        this.active = index
            if(index===0){
                this.$router.push({
                    path:'/database/bioOmics'
                })
            }else if(index === 1){
                this.$router.push({
                    path:'/database/sciSmart'
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .introduce{
        width: 100%;
        height: 230px;
        padding: 30px 0;
        box-sizing: border-box;
        box-shadow: 0 3px 10px rgba(51, 51, 51, 0.26);
        &>div{
            width: 1000px;
            height: 182px;
            margin: 0 auto;
            box-sizing: border-box;
            border-left: 1px solid #e6e6e6;
            border-right: 1px solid #e6e6e6;
            display: flex;
            justify-content: space-between;
            position: relative;
            &>div{
                width: 478px;
                height: 100%;
                text-align: center;
                box-sizing: border-box;
                padding-top: 15px;
                font-size: 22px;
                letter-spacing: 4px;
                cursor: pointer;
                div{
                    margin-top: 15px;
                }
            }
            .active{
                width: 522px;
                height: 250px;
                /*position: absolute;*/
                /*top: -40px;*/
                /*left: 360px;*/
                margin-top: -42px;
                background: url("../assets/img/products/introduceBg.png") 100% 100%;
                padding-top: 44px;
                box-sizing: border-box;
                box-shadow:rgba(51, 51, 51, 0.8) 0px 0px 10px ;
                position: relative;
                div{
                    /*color: #fff;*/
                    line-height: 40px;
                }

            }
        }
    }
</style>
